import PouchDB from 'pouchdb/dist/pouchdb.js'
//import PouchDBFind from 'pouchdb-find/lib'

//PouchDB.plugin(PouchDBFind)

export default PouchDB
